module.exports = __webpack_public_path__ + "static/media/steer.70a26d41.svg";